import React, { useEffect, useState } from "react";
import "./Synergie.css";
import Footer from "./Footer";

const Synergie = () => {
  
  
  const synergies = [
    {
      type: "Fire",
      color: "#FF5733", // Rot für Feuer
      images: [
        { src: "http://poke-meta.com/static/images/pokemon/glumanda.png", name: "Glumanda" },
        { src: "http://poke-meta.com/static/images/pokemon/fynx.png", name: "Fynx" },
        { src: "http://poke-meta.com/static/images/pokemon/hopplo.png", name: "Hopplo" }
      ],
      bonuses: [
        " 2 Fire-Pokémon = This damage is increased by 8%",
        " 3 Fire-Pokémon = This damage is increased by 16%",
        " 4 Fire-Pokémon = This damage is increased by 24%",
        " 5 Fire-Pokémon = This damage is increased by 36% (this buff cannot be cleansed)",
        " 6 Fire-Pokémon = This damage is increased by 50% (buff cannot be cleansed, affected targets deal 70% less damage)"
      ]
    },
    {
      type: "Water",
      color: "#3498db", // Blau für Wasser
      images: [
        { src: "http://poke-meta.com/static/images/pokemon/enton.png", name: "enton" },
        { src: "http://poke-meta.com/static/images/pokemon/urgl.png", name: "urgl" },
        { src: "http://poke-meta.com/static/images/pokemon/schiggy.png", name: "schiggy" },
        { src: "http://poke-meta.com/static/images/pokemon/froxy.png", name: "froxy" },
        { src: "http://poke-meta.com/static/images/pokemon/lapras.png", name: "Lapras" },
        { src: "http://poke-meta.com/static/images/pokemon/memmeon.png", name: "memmeon" }
      ],
      bonuses: [
        " 2 Increase ATK and SP ATK by 10%",
        " 3 Increase ATK and SP ATK by 20%",
        " 4 Increase DEF AND SP DEF by 120",
        " 5 Huge waves” will spawn occasionally that deal damage to enemies",
        " 6 Huge waves” deal more damage and cleanse hindrances for allies"
      ]
    }
    ,
    {
      type: "Ice",
      color: "#08eff7", // Blau für Wasser
      images: [
        { src: "http://poke-meta.com/static/images/pokemon/quiekel.png", name: "quiekel" },
        { src: "http://poke-meta.com/static/images/pokemon/vulpix.png", name: "vulpix" },
        { src: "http://poke-meta.com/static/images/pokemon/lapras.png", name: "lapras" },
        { src: "http://poke-meta.com/static/images/pokemon/glaciola.png", name: "glaciola" }
      ],
      bonuses: [
        " 2 Each stack of Frost adds 2% extra damage.",
        " 3 Each stack of Frost adds 4% extra damage.",
        " 4 Each stack of Frost adds 8% extra damage",
        " 5 Summons Articuno after 10 seconds!"
      ]
    }
    ,
    {
      type: "Psychic",
      color: "#f307ec", // Blau für Wasser
      images: [
        { src: "http://poke-meta.com/static/images/pokemon/trasla.png", name: "enton" },
        { src: "http://poke-meta.com/static/images/pokemon/fynx.png", name: "camorant" },
        { src: "http://poke-meta.com/static/images/pokemon/pantimos.png", name: "shhiggy" },
        { src: "http://poke-meta.com/static/images/pokemon/psiana.png", name: "froxy" }
      ],
      bonuses: [
        " 2 Restore 2 points of Move Progress per second.",
        " 3 Restore 4 points of Move Progress per second",
        " 4 Restore 6 points of Move Progress per second",
        " 5 Restore 8 points of Move Progress per second. Start battle with full Move Progress",
        " 6 Each time a move is used, it’s damage is increased by 40%. (Stacks?)"
      ]
    }
    ,
    {
      type: "Fairy",
      color: "#fcbdfa", // Blau für Wasser
      images: [
        { src: "http://poke-meta.com/static/images/pokemon/pummeluff.png", name: "enton" },
        { src: "http://poke-meta.com/static/images/pokemon/pantimos.png", name: "camorant" },
        { src: "http://poke-meta.com/static/images/pokemon/feelinara.png", name: "shhiggy" },
        { src: "http://poke-meta.com/static/images/pokemon/pixi.png", name: "froxy" }
      ],
      bonuses: [
        " 2 Summons Zacian. (1 Star)",
        " 3 Summons Zacian. (2 Star, uses Metal Claw as a move.)",
        " 4 Summons Zacian. (2 star, uses Metal Claw as a move.)",
        " 5 Summons Zacian. (3 star, uses Metal Claw as a move, has Drain Crown equipped.)",
        " 6 Summons Zacian. (3 star, uses Metal Claw as a move, has Drain Crown and Technical Machine equipped to use Behemoth Blade as a special move.)"
      ]
    }
    ,
    {
      type: "Star Eevee",
      color: "#ba4c04", // Blau für Wasser
      images: [
        { src: "http://poke-meta.com/static/images/pokemon/nachtara.png", name: "enton" },
        { src: "http://poke-meta.com/static/images/pokemon/folipurba.png", name: "camorant" },
        { src: "http://poke-meta.com/static/images/pokemon/psiana.png", name: "shhiggy" },
        { src: "http://poke-meta.com/static/images/pokemon/feelinara.png", name: "froxy" },
        { src: "http://poke-meta.com/static/images/pokemon/glaciola.png", name: "Lapras" },
      ],
      bonuses: [
        " 2 +10% Damage",
        " 3 AND +10% Damage Reduction",
        " 4 AND gain 4 Move Progress when dealing normal attack damage",
        " 5 AND +30% Move Damage",
        " 6 AND when using a move, a meteor will spawn and attack a random opponent."
      ]
    }
    ,
    {
      type: "Electric",
      color: "#f0e310", // Blau für Wasser
      images: [
        { src: "http://poke-meta.com/static/images/pokemon/pikachu.png", name: "pikachu" },
        { src: "http://poke-meta.com/static/images/pokemon/zeraora.png", name: "zeraora" },
        { src: "http://poke-meta.com/static/images/pokemon/zapdos.png", name: "zapdos" },
      ],
      bonuses: [
        " 2 After 6 instances of damage, cause one Electric Shock.",
        " 3 After 3 instances of damage, cause one Electric Shock."
      ]
    }
    ,
    {
      type: "Fighting",
      color: "#e35c09", // Blau für Wasser
      images: [
        { src: "http://poke-meta.com/static/images/pokemon/machollo.png", name: "enton" },
        { src: "http://poke-meta.com/static/images/pokemon/lucario.png", name: "camorant" },
        { src: "http://poke-meta.com/static/images/pokemon/dakuma.png", name: "shhiggy" }
      ],
      bonuses: [
        " 2 +12% Lifesteal. ATK SPD increases by 4% after each normal attack.",
        " 3 +24% Lifesteal. ATK SPD increases by 8% after each normal attack",
        " 4 +40% HP regeneration. ATK SPD increases by 12% after each normal attack",
        " 5 +60% Lifesteal. ATK SPD no longer increases, but +260% normal attack damage",
        " 6 Steal 60% of target’s ATK. Normal attacks deal extremely high damage"
      ]
    }
    ,
    {
      type: "Dark",
      color: "#292726", // Blau für Wasser
      images: [
        { src: "http://poke-meta.com/static/images/pokemon/zorua.png", name: "enton" },
        { src: "http://poke-meta.com/static/images/pokemon/nachtara.png", name: "camorant" },
        { src: "http://poke-meta.com/static/images/pokemon/absol.png", name: "shhiggy" },
        { src: "http://poke-meta.com/static/images/pokemon/despotar.png", name: "froxy" }
      ],
      bonuses: [
        " 2 Reduce the opponent’s ATK and SP ATK by 5%, and their DEF by 30",
        " 3 Reduce the opponent’s ATK and SP ATK by 7%, and their DEF and SP DEF by 90",
        " 4 Reduce the opponent’s ATK and SP ATK by 10%, and their DEF and SP DEF by 40%+120",
        "Bonus: When an opponent is knocked out, gain one Fear Aura stack. Only Dark Pokemon can benefit from the effects of Fear Aura",
        "Fear Aura: X5 – Increase ATK by 5%. ",
        "Fear Aura: X15 – Increase ATK by 10%. ",
        "Fear Aura: X25 – Increase ATK by 20%. ",
        "Fear Aura: X40 – Increase ATK by 30%. ",
        "Fear Aura: X60 – Increase ATK by 60%. "
      ]
    }
    ,
    {
      type: "Grass",
      color: "#109b05", // Blau für Wasser
      images: [
        { src: "http://poke-meta.com/static/images/pokemon/bauz.png", name: "bauz" },
        { src: "http://poke-meta.com/static/images/pokemon/bisasam.png", name: "bisasam" },
        { src: "http://poke-meta.com/static/images/pokemon/folipurba.png", name: "folipurba" },
        { src: "http://poke-meta.com/static/images/pokemon/frubberl.png", name: "froxy" },
        { src: "http://poke-meta.com/static/images/pokemon/cottini.png", name: "Lapras" }
      ],
      bonuses: [
        " 2 Restore 1% HP every 3 seconds. Gain 2 stacks of New Green upon ally KO",
        " 3 Restore 2% HP every 3 seconds. Gain 3 stacks of New Green upon ally KO",
        " 4 Restore 3% HP every 3 seconds. Gain 4 stacks of New Green upon ally KO",
        " 5 Restore 4% HP every 3 seconds. Gain 5 stacks of New Green upon ally KO",
        "Bonus: When the total number of New Green stacks reaches certain breakpoints, they can be consumed for prizes. (Prizes are random items or Pokemon of varying Star level.) Stacks of New Green can be consumed at any time.",
        "X10 – Can be exchanged for 1 common reward",
        "X40 - Can be exchanged for 1 common reward. ",
        "X80 - Can be exchanged for 1 rare reward.",
        "X140 – Can be exchanged for 2 rare rewards",
        "X180 – Can be exchanged 3 super rare rewards"
      ]
    }
    ,
    {
      type: "Rock",
      color: "#69532c", // Blau für Wasser
      images: [
        { src: "http://poke-meta.com/static/images/pokemon/Lithomith.png", name: "enton" },
        { src: "http://poke-meta.com/static/images/pokemon/despotar.png", name: "camorant" }
      ],
      bonuses: [
        " 2 X2 – +150 SP DEF.",
      ]
    }
    ,
    {
      type: "Dragon",
      color: "#563804", // Blau für Wasser
      images: [
        { src: "http://poke-meta.com/static/images/pokemon/dragoran.png", name: "enton" }
      ],
      bonuses: [
        " 2 +5% ATK SPD"
      ]
    }
    ,
    {
      type: "Troublemaker",
      color: "#3e1a04", // Blau für Wasser
      images: [
        { src: "http://poke-meta.com/static/images/pokemon/gengar.png", name: "enton" }
      ],
      bonuses: [
        " 2 +15% SP ATK"
      ]
    }
    ,
    {
      type: "behemoth",
      color: "#d76e2e", // Blau für Wasser
      images: [
        { src: "http://poke-meta.com/static/images/pokemon/relaxo.png", name: "enton" }
      ],
      bonuses: [
        " 2 +90 DEF and SP DEF"
      ]
    }
    ,
    {
      type: "Guardian",
      color: "#69114c", // Blau für Wasser
      images: [
        { src: "http://poke-meta.com/static/images/pokemon/Lithomith.png", name: "enton" },
        { src: "http://poke-meta.com/static/images/pokemon/quiekel.png", name: "camorant" },
        { src: "http://poke-meta.com/static/images/pokemon/schiggy.png", name: "shhiggy" },
        { src: "http://poke-meta.com/static/images/pokemon/pantimos.png", name: "froxy" },
        { src: "http://poke-meta.com/static/images/pokemon/cottini.png", name: "Lapras" },
        { src: "http://poke-meta.com/static/images/pokemon/relaxo.png", name: "das andere" }
      ],
      bonuses: [
        " 2 +60 DEF and SP DEF",
        " 3 +120 DEF and SP DEF",
        " 4 +240 DEF and SP DEF"
      ]
    }
    ,
    {
      type: "Speedy",
      color: "#fac541", // Blau für Wasser
      images: [
        { src: "http://poke-meta.com/static/images/pokemon/zorua.png", name: "enton" },
        { src: "http://poke-meta.com/static/images/pokemon/urgl.png", name: "camorant" },
        { src: "http://poke-meta.com/static/images/pokemon/hopplo.png", name: "shhiggy" },
        { src: "http://poke-meta.com/static/images/pokemon/glaciola.png", name: "froxy" },
        { src: "http://poke-meta.com/static/images/pokemon/absol.png", name: "Lapras" }
      ],
      bonuses: [
        " 2 +10% ATK SPD",
        " 3 +20% ATK SPD",
        " 4 +40% ATK SPD"
      ]
    }
    ,
    {
      type: "Burst",
      color: "#970f2e", // Blau für Wasser
      images: [
        { src: "http://poke-meta.com/static/images/pokemon/bisasam.png", name: "enton" },
        { src: "http://poke-meta.com/static/images/pokemon/fynx.png", name: "camorant" },
        { src: "http://poke-meta.com/static/images/pokemon/feelinara.png", name: "shhiggy" },
        { src: "http://poke-meta.com/static/images/pokemon/memmeon.png", name: "froxy" },
        { src: "http://poke-meta.com/static/images/pokemon/gengar.png", name: "Lapras" }
      ],
      bonuses: [
        " 2 Increase ATK and SP ATK by 10%",
        " 3 Increase ATK and SP ATK by 20%",
        " 4 Increase DEF AND SP DEF by 120"
      ]
    }
    ,
    {
      type: "Skilled",
      color: "#3b936a", // Blau für Wasser
      images: [
        { src: "http://poke-meta.com/static/images/pokemon/pikachu.png", name: "enton" },
        { src: "http://poke-meta.com/static/images/pokemon/trasla.png", name: "camorant" },
        { src: "http://poke-meta.com/static/images/pokemon/vulpix.png", name: "shhiggy" },
        { src: "http://poke-meta.com/static/images/pokemon/psiana.png", name: "froxy" },
        { src: "http://poke-meta.com/static/images/pokemon/zapdos.png", name: "Lapras" }
      ],
      bonuses: [
        " 2 +10% SP ATK",
        " 3 +20% SP ATK",
        " 4 +40% SP ATK"
      ]
    }
    ,
    {
      type: "Support",
      color: "#fa05bb", // Blau für Wasser
      images: [
        { src: "http://poke-meta.com/static/images/pokemon/enton.png", name: "enton" },
        { src: "http://poke-meta.com/static/images/pokemon/pummeluff.png", name: "camorant" },
        { src: "http://poke-meta.com/static/images/pokemon/nachtara.png", name: "shhiggy" },
        { src: "http://poke-meta.com/static/images/pokemon/pixi.png", name: "froxy" }
      ],
      bonuses: [
        " 2 Increase ATK and SP ATK by 10%",
        " 3 Increase ATK and SP ATK by 20%",
        " 4 Increase DEF AND SP DEF by 120"
      ]  
      }
    ,
    {
      type: "Offensive",
      color: "#a90332", // Blau für Wasser
      images: [
        { src: "http://poke-meta.com/static/images/pokemon/bauz.png", name: "bauz" },
        { src: "http://poke-meta.com/static/images/pokemon/lucario.png", name: "lucario" },
        { src: "http://poke-meta.com/static/images/pokemon/folipurba.png", name: "folipurba" },
        { src: "http://poke-meta.com/static/images/pokemon/froxy.png", name: "froxy" },
        { src: "http://poke-meta.com/static/images/pokemon/cottini.png", name: "cottini" },
        { src: "http://poke-meta.com/static/images/pokemon/dragoran.png", name: "dragoran" }
      ],
      bonuses: [
        " 2 +10% ATK",
        " 3 +20% ATK",
        " 4 +40% ATK"
      ]
    }
    ,
    {
      type: "Universal",
      color: "#4d7c21", // Blau für Wasser
      images: [
        { src: "http://poke-meta.com/static/images/pokemon/machollo.png", name: "enton" },
        { src: "http://poke-meta.com/static/images/pokemon/folipurba.png", name: "camorant" },
        { src: "http://poke-meta.com/static/images/pokemon/dakuma.png", name: "shhiggy" },
        { src: "http://poke-meta.com/static/images/pokemon/despotar.png", name: "froxy" }
      ],
      bonuses: [
        " 2 +5% Damage and Damage Reduction",
        " 3 +10% Damage and Damage Reduction",
        " 4 +20% Damage and Damage Reduction"
      ]
    }
    
  ];
  const synergyTypes = synergies.map((synergy) => synergy.type);

  // **State für die Position des Filters**
  const [filterPosition, setFilterPosition] = useState(50); // Startposition

  // **Scroll-Event, um den Filter beweglich zu machen**
  useEffect(() => {
    const handleScroll = () => {
      const newPosition = Math.max(50, window.scrollY + 20); // Mindestens 50px von oben
      setFilterPosition(newPosition);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // **Springt zur gewählten Synergie-Kategorie**
  const handleFilterChange = (e) => {
    const selectedType = e.target.value;
    const element = document.getElementById(selectedType.toLowerCase());
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div className="synergies-container">
      {/* Beweglicher Filter-Dropdown */}
      <div className="floating-filter" style={{ top: `${filterPosition}px` }}>
        <select className="filter-dropdown" onChange={handleFilterChange} defaultValue="">
          <option value="" disabled>Filter by Synergy Type</option>
          {synergyTypes.map((type, index) => (
            <option key={index} value={type}>{type}</option>
          ))}
        </select>
      </div>

      {/* Synergie-Sektionen */}
      {synergies.map((synergy, index) => (
        <div key={index} id={synergy.type.toLowerCase()} className="synergy-box led-border" style={{    boxShadow: `0px 0px 15px ${synergy.color}`,
        "--ledColor": `${synergy.color}`}}>
          <h1 className="synergy-title" style={{ color: synergy.color }}>
            {synergy.type} Synergy
          </h1>
          <div className="synergy-images">
            {synergy.images.map((pokemon, idx) => (
              <div key={idx} className="synergy-image-container">
                <img src={pokemon.src} alt={pokemon.name} className="synergy-image" />
              </div>
            ))}
          </div>
          <div className="synergy-text">
            <h2>Bonuses</h2>
            <ul>
              {synergy.bonuses.map((bonus, i) => (
                <li key={i}>{bonus}</li>
              ))}
            </ul>
          </div>
        </div>
      ))}

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Synergie;